export interface IUploadUsersVerifyResponse {
  associationsBeforeUpload?: number;
  associationsAfterUpload?: number;
  validationErrors?: IValidationError[];
}

export type ValidationErrorType =
  | "INVALID_FILE_EMPTY"
  | "INVALID_FILE_FORMAT"
  | "INVALID_FILE_SHEET"
  | "INVALID_FILE_HEADER"
  | "INVALID_EMAIL_FORMAT"
  | "MISSING_TID"
  | "INVALID_TID"
  | "INVALID_TYPE_TID"
  | "USERNAME_NOT_EXISTS"
  | "USERNAME_EMAIL_MISMATCH"
  | "ROLE_TOO_LONG"
  | "MISSING_EMAIL";

export const errorMapping = {
  INVALID_FILE_EMPTY: "Il file è vuoto",
  INVALID_FILE_SHEET:
    'Il foglio del file non è valido. Per ottenere un file valido modifica il file "elenco utenti attuali" che puoi scaricare da questa sezione',
  INVALID_FILE_FORMAT:
    'Formato del file non valido. Per ottenere un file valido modifica il file "elenco utenti attuali" che puoi scaricare da questa sezione',
  INVALID_FILE_HEADER:
    "Intestazione del file non valida. Non modificare il nome del file e delle colonne.",
  INVALID_EMAIL_FORMAT: "non è corretto, elimina simboli o spazi bianchi oppure aggiungi la @ o il punto.",
  MISSING_TID: "Non è valorizzato il campo TID",
  INVALID_TID: "non è attivo sul punto vendita corrente",
  INVALID_TYPE_TID: "",
  USERNAME_NOT_EXISTS: "Il campo username viene generato automaticamente dal sistema. Se stai creando un'utenza lascia vuoto il campo, se stai modificando un'utenza già esistente l'username non può essere cambiato.",
  USERNAME_EMAIL_MISMATCH: "non corrisponde all'email",
  ROLE_TOO_LONG: "supera i 20 caratteri consentiti",
  MISSING_EMAIL: "Non è valorizzato il campo Email",
};

export interface IValidationError {
  type: ValidationErrorType;
  row?: number;
  value?: string;
  field?: string;
  additionalValue?: string;
}

export class UploadUsersVerifyResponse implements IUploadUsersVerifyResponse {
  public associationsBeforeUpload?: number;
  public associationsAfterUpload?: number;
  public validationErrors?: IValidationError[];

  constructor(
    associationsBeforeUpload?: number,
    associationsAfterUpload?: number,
    validationErrors?: IValidationError[]
  ) {
    this.associationsBeforeUpload = associationsBeforeUpload;
    this.associationsAfterUpload = associationsAfterUpload;
    this.validationErrors = validationErrors;
  }
}
